import { render, staticRenderFns } from "./VTabPane.vue?vue&type=template&id=1b899d8b&scoped=true&"
import script from "./VTabPane.vue?vue&type=script&lang=js&"
export * from "./VTabPane.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b899d8b",
  null
  
)

export default component.exports